{
  "screen": {
    "sectionHeading": "Fallecimiento",
    "open": "Registrar fallecimiento",
    "openCorrection": "Corregir el fallecimiento",
    "heading": "Registrar fallecimiento",
    "correctionHeading": "Corregir el fallecimiento",
    "explanation": "Registra que el paciente ha fallecido. Usted constará como el médico que constató el fallecimiento, y el registro se firma en su nombre. El ingreso continúa y la cama se mantiene hasta que se dé el alta al paciente.",
    "correctionExplanation": "La corrección será una nueva versión. La anterior permanece en la historia clínica. El médico que constató el fallecimiento sigue constando.",
    "requiredHint": "Los campos sin indicación son obligatorios.",
    "optional": "opcional",
    "final": "Un registro de fallecimiento no se puede eliminar. Si es erróneo, corríjalo, o retírelo si corresponde a otro paciente.",
    "save": "Registrar y firmar",
    "saveCorrection": "Guardar la corrección y firmar",
    "saving": "Guardando …",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "saved": "El fallecimiento está registrado y firmado.",
    "savedCorrection": "La corrección está guardada y firmada.",
    "discardQuestion": "¿Cerrar el formulario? No se registrará nada.",
    "discardConfirm": "Cerrar sin guardar",
    "discardCancel": "Seguir rellenando",
    "physicianOnly": "Solo un médico puede registrar un fallecimiento, porque quien lo registra consta como quien lo constató."
  },
  "field": {
    "diedAt": "Hora del fallecimiento",
    "estimated": "La hora es estimada: el paciente fue encontrado fallecido",
    "pronouncedAt": "Fallecimiento constatado",
    "police": "Comunicado a la policía",
    "note": "Circunstancias",
    "withdraw": "El registro corresponde a otro paciente o es erróneo: retirarlo"
  },
  "fieldHint": {
    "diedAt": "AAAA-MM-DD HH:MM, formato de 24 horas. Modifíquelo si el fallecimiento ocurrió antes de ahora.",
    "pronouncedAt": "Cuándo constató usted el fallecimiento, AAAA-MM-DD HH:MM. No antes de la hora del fallecimiento.",
    "police": "La policía decide sobre el examen médico-forense. Seleccione una respuesta: no hay ninguna preseleccionada.",
    "note": "Cómo y dónde se encontró al paciente, quién estaba presente. No escriba aquí la causa de muerte: corresponde al certificado de causa de muerte."
  },
  "police": {
    "notified": "Sí, comunicado a la policía",
    "not-notified": "No, no comunicado",
    "not-assessed": "Aún no valorado"
  },
  "banner": {
    "died": "Fallecido {diedAt}",
    "diedEstimated": "Fallecido hacia {diedAt} (hora estimada)",
    "pronounced": "Constatado {pronouncedAt} por {name}",
    "police": "Denuncia a la policía: {answer}"
  },
  "refusal": {
    "timeMissing": "Rellene el campo “{field}”. No se ha registrado nada.",
    "timeMalformed": "“{field}” no se reconoce como una hora. Escríbala como AAAA-MM-DD HH:MM, por ejemplo 2026-10-15 08:00. No se ha registrado nada.",
    "timeInFuture": "“{field}” está en el futuro. No se ha registrado nada.",
    "pronouncedBeforeDeath": "El fallecimiento no puede haberse constatado antes de producirse. Compruebe las dos horas. No se ha registrado nada.",
    "policeMissing": "Indique si el fallecimiento se ha comunicado a la policía. No se ha registrado nada.",
    "fieldTooLong": "Las circunstancias son demasiado largas. Acórtelas a un máximo de {max} caracteres. No se ha registrado nada.",
    "alreadyRecorded": "Ya hay un fallecimiento registrado para este paciente. La vista general está actualizada: corrija ese registro. No se ha registrado nada.",
    "noChange": "La corrección no modifica nada. No se ha guardado nada.",
    "stale": "Otra persona ha modificado el registro mientras el formulario estaba abierto. La vista general está actualizada: compruébelo e inténtelo de nuevo. No se ha guardado nada.",
    "retracted": "El registro ya está retirado y no se puede corregir.",
    "notFound": "El registro no consta en la historia clínica. Vuelva a abrir la vista general del paciente.",
    "patientNotFound": "El paciente no consta en la historia clínica. No se ha registrado nada.",
    "roleMayNotEstablishDeath": "Solo un médico puede registrar un fallecimiento. No se ha registrado nada.",
    "unknown": "No se ha registrado nada. Inténtelo de nuevo.",
    "unavailable": "Sin conexión con el servidor. No es seguro que el registro se haya guardado: vuelva a abrir la vista general del paciente y compruébelo antes de intentarlo de nuevo."
  }
}
